var exports = {
  "jW": "x31de4314--922616--photo",
  "pq": "x31de4314--922616--info",
  "q9": "x31de4314--922616--price",
  "nf": "x31de4314--922616--link",
  "kZ": "x31de4314--922616--location-container",
  "qP": "x31de4314--922616--highway-icon",
};

module.exports = exports;
